import Application from '@/shared/application.js'

new Application({
  data () {
    return {
      location: 0,
      season: 'all',
      type: 'all',

      events: [],
      searchID: '',
      hasMoreResults: false,
      resultPage: 1,

      videoSource: 'youtube',
      videoID: '',
    }
  },

  methods: {
    init() {
      this.setData()
    },

    updateSearch() {
      this.resultPage = 1
      this.updateResults()
    },

    updateResults() {
      this.$http.get(location.path || '/', {
        params: {
          location: this.location,
          season: this.season,
          type: this.type,
          page: this.resultPage,
        }
      })
      .then(response => {
        const data = response.data
        if (this.resultPage === 1) {
          this.events = data.events
        } else {
          this.events = [...this.events, ...data.events]
        }

        this.hasMoreResults = data.moreResults

        let search = data.search
        if (search.hash !== this.searchID) {
          this.searchID = search.hash
          this.updateUrlForSearch(data.search)
        }
      })
    },

    updateUrlForSearch(search) {
      let path = location.path || '/'
      history.pushState({search: search}, 'zoekresultaat', path +'?search='+ search.hash)
    },

    listenForSearchChange() {
      window.addEventListener('popstate', (event) => {
        if (! event.state || ! event.state.search ) {
          return
        }

        let search = event.state.search
        this.setSearchProperties(search)
        this.updateSearch()
      })
    },

    setSearchProperties(search) {
      if (! search || ! search.properties) {
        return
      }

      let props = search.properties
      for (let key in props) {
        this[key] = props[key]
      }

      this.searchID = search.hash
    },

    loadMoreResults() {
      this.resultPage++
      this.updateResults()
    },

    gotoEvent(event) {
      location.href = event.url
    },

    setData() {
      this.location = _state.location
      this.events = _state.events.events
      this.hasMoreResults = _state.events.moreResults
      this.setSearchProperties(_state.events.search)
    },

    showVideo(source, videoID) {
      this.videoSource = source
      this.videoID = videoID
      this.$modal.open('video')
    },

    closeVideo() {
      setTimeout(() => {
        this.videoID = ''
      }, 300)
    }
  },

  created() {
    this.init()
    this.listenForSearchChange()
  },

  mounted() {
    try {
      this.$modal.open('corona')
    } catch (e) {
      // nada
    }
  },
})



// WEBPACK FOOTER //
// ./resources/assets/front/js/modules/home.js